export default [
  {
    path: '/powerups',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Power Ups',
        path: '',
        component: () => import('@/views/powerups/Index.vue'),
        meta: {
          requiresAuth: true,
          routeReleasedForLite: true,
          breadcrumb: [{ name: 'Power Ups' }]
        }
      }
    ]
  }
];
